<template>
  <div class="bg-container page bc-img">
    <div class="bg-wrapper bc-body bc-box bc-img">
      <div class="register">
        <van-nav-bar class="nav-bar" :title="$t('auth.register')">
          <template #left>
            <van-icon name="arrow-left" color="#fff" @click="back()" />
          </template>
          <!-- <template #right>
            <div class="language" @click="$router.push('/language')">
              <img :src="require('../../assets/bc-img/nav10.png')" />
            </div>
          </template> -->
        </van-nav-bar>
        <div class="wrapper">
          <div class="beauty-motion" aria-hidden="true">
            <img src="../../assets/bc-img/n1.jpg" alt="" class="beauty-img beauty-img-one" />
            <img src="../../assets/bc-img/n2.jpg" alt="" class="beauty-img beauty-img-two" />
            <img src="../../assets/bc-img/n3.jpg" alt="" class="beauty-img beauty-img-three" />
          </div>
          <!-- <div class="logo-container">
						<div class="logo-wrapper">
							<img class="logo-img"
								:src="this.$store.getters.getBaseInfo.ico !==undefined ?this.$store.getters.getBaseInfo.ico:''">
						</div>
					</div>
					<div class="title">{{$t("auth.register")}}</div> -->
          <div class="icon-top">
            <!-- <img src="../../assets/bc-img/logo.png" alt="" class="icon-img" /> -->
            <div class="top1">
              <img src="../../assets/bc-img/logo.png" alt="Meet" class="brand-logo" />
            </div>
            <div class="top2">{{ $t("auth.register") }}</div>
            <div class="top3">{{ $t("auth.register") }}</div>
          </div>
          <div class="loginForm">
            <div class="input1">
              <label>{{ $t("auth.login") }}</label>
              <van-field
                v-model="username"
                clearable
                class="input"
                :placeholder="$t('auth.username_place')"
                :border="false"
              />
            </div>
            <div class="input1">
              <label>{{ $t("auth.Login_password") }}</label>
              <van-field
                v-model="password"
                :type="passwordType[0]"
                class="input"
                :placeholder="$t('auth.pwd_place')"
                :border="false"
              >
                <template slot="right-icon">
                  <van-icon
                    :name="
                      passwordType[0] === 'password' ? 'closed-eye' : 'eye-o'
                    "
                    @click="switchPasswordType(0)"
                  />
                </template>
              </van-field>
            </div>
            <div class="input1">
              <label>{{ $t("auth.confirm_password") }}</label>
              <van-field
                v-model="password_s"
                :type="passwordType[1]"
                class="input"
                :placeholder="$t('auth.confirm_password_place')"
                :border="false"
              >
                <template slot="right-icon">
                  <van-icon
                    :name="
                      passwordType[1] === 'password' ? 'closed-eye' : 'eye-o'
                    "
                    @click="switchPasswordType(1)"
                  />
                </template>
              </van-field>
            </div>
            <div class="input1">
              <label>{{ $t("auth.register") }}</label>

              <van-field
                v-model="code"
                clearable
                class="input"
                :placeholder="$t('auth.invite_code_place')"
                :border="false"
              />
            </div>
            <!-- <div class="agreement">
              <van-checkbox v-model="checked" checked-color="#e7b58e" />
              <span class="agreement-text">{{
                $t("auth.agreement_place")
              }}</span>
            </div> -->
            <van-button
              class="login-btn"
              type="primary"
              size="normal"
              @click="doRegister()"
              >{{ $t("auth.register") }}</van-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      checked: true,
      username: "",
      code: "",
      lang: "en_us",
      password: this.inputValue,
      password_s: "",
      passwordType: ["password", "password"],
      name: "",
    };
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || "zh_tw";
  },
  methods: {
    switchPasswordType(index) {
      const password_arr = JSON.parse(JSON.stringify(this.passwordType));
      password_arr[index] =
        password_arr[index] === "password" ? "text" : "password";
      this.passwordType = password_arr;
    },
    back() {
      return window.history.back();
    },
    doRegister() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if (new RegExp("/^[0-9]{9}([0-9]{1})?$/").test(this.username)) {
        this.$toast.fail(this.$t("setting.mobile_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if (
        this.password_s === "" ||
        this.password_s === null ||
        this.password_s === undefined
      ) {
        this.$toast.fail(this.$t("auth.confirm_password_place"));
        return false;
      }
      if (this.password_s !== this.password) {
        this.$toast.fail(this.$t("setting.pwd_error"));
        return false;
      }
      // if (this.name == "") {
      //   this.$toast.fail(this.$t("setting.name"));
      //   return false;
      // }
      if (this.code === "" || this.code === null || this.code === undefined) {
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }
      if (!this.checked) {
        this.$toast.fail(this.$t("auth.agreement"));
        return false;
      }
      this.$http({
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          code: this.code,
        },
        url: "member_register",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data);
          this.$router.push("Mine");
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.less";
::v-deep .van-field__control {
  &::placeholder {
    color: #444 !important;
  }
}
::v-deep .van-nav-bar__title {
  display: none !important;
}
::v-deep .van-nav-bar .van-icon {
  color: #bbbbbb !important;
  padding: 0.8rem;
  border: 1px solid #444;
  border-radius: 1rem;
}
::v-deep .van-nav-bar__content {
  background: none !important;
}
.icon-top {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: auto;
  padding: 1.5rem 1.5rem;
  background: linear-gradient(to bottom right, #33251a, #1b1435);
  opacity: 0.85;
  margin-top: 1.2rem;
  border: 1px solid #444;
  border-radius: 1rem;
  .top1 {
    display: flex;
    align-items: center;
    min-height: 2.4rem;
  }
  .brand-logo {
    display: block;
    width: 8.8rem;
    max-width: 64vw;
    height: auto;
  }
  .top2 {
    color: #d2ab84;
    font-weight: lighter !important;
    margin: 0.5rem 0;
  }
  .top3 {
    color: #fff;
    font-size: 2rem;
  }
  // .icon-img{
  //   width: 30%;
  //   // height: 6rem;
  //   border: 1px solid rgba(255, 255, 255, 0.2);
  //   border-radius: 1rem;
  // }
}
.language {
  border: 1px solid hsla(0, 0%, 100%, 0.12);
  border-radius: 0.7rem;
  padding: 0.4rem;
  display: flex;
  align-items: center;
  img {
    height: 40px;
  }
}
.bc-box {
  background: rgba(0, 0, 0, 0.4);
}

.bc-body {
  padding: 1rem;
}

.bc-img {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.18), rgba(0, 0, 0, 0.9)),
    url("/img/bg.e6263671.jpg") no-repeat center top;
  // background-size: cover;
  // transform: scale(1.04);
  filter: saturate(1.05);
  // background-image: url(../../assets/bc-img/bgi.png);
  background-size: cover, auto 60%;
  animation: authBgSway 4.8s ease-in-out infinite alternate;
  will-change: background-position;
}
@keyframes authBgSway {
  from {
    background-position: center center, calc(50% - 1rem) top;
  }
  to {
    background-position: center center, calc(50% + 1rem) top;
  }
}
.beauty-motion {
  position: relative;
  height: 7rem;
  margin: 0.6rem 0 0.8rem;
  border-radius: 1.1rem;
  overflow: hidden;
  border: 1px solid rgba(244, 197, 125, 0.38);
  background: #110d13;
  box-shadow: 0 0.8rem 2rem rgba(0, 0, 0, 0.35);
}
.beauty-motion::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(12, 8, 12, 0.2), rgba(12, 8, 12, 0.66)),
    linear-gradient(180deg, rgba(255, 206, 142, 0.12), rgba(0, 0, 0, 0.45));
}
.beauty-img {
  position: absolute;
  top: 0;
  width: 48%;
  height: 100%;
  object-fit: cover;
  filter: saturate(1.08) contrast(1.04);
  animation: beautyDrift 8s ease-in-out infinite alternate;
}
.beauty-img-one {
  left: 0;
}
.beauty-img-two {
  left: 28%;
  animation-delay: -2s;
}
.beauty-img-three {
  right: 0;
  animation-delay: -4s;
}
@keyframes beautyDrift {
  from {
    transform: scale(1.04) translate3d(-0.35rem, 0, 0);
  }
  to {
    transform: scale(1.12) translate3d(0.35rem, 0, 0);
  }
}

.register {
  height: 100%;
}

.register .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.logo-container {
  margin: 0 auto;
  width: 45%;
}

.logo-container .logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}

.logo-container .logo-wrapper .logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}

.register .wrapper .title {
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 5px;
}

.register .wrapper .loginForm {
  padding: @pd1;
  // background: @theme1;
  // margin-top: 5%;
  border-radius: 2rem;
  border: 1px solid #2a2a2a;
  margin-top: 1.5rem;

  label {
    display: inline-block;
    margin: 0 0;
    color: #fff;
    font-weight: lighter !important;
  }
  .input1 {
    border-radius: 1rem;
    border: 1px solid #2a2a2a;
    padding: 1rem 1rem;
    background-color: #111015;
    margin-bottom: 1rem;
  }
}

.register .wrapper .loginForm .input {
  padding: 0 20px;
  background: @input_bg;
  border-radius: @br1;
  text-align: center;
  line-height: 80px;
  font-size: 30px;
  border: 1px solid #2a2a2a;
  margin-top: 1rem;
  /deep/ input {
    color: #ccc;
  }
}

::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}

::v-deep .van-icon {
  font-size: 50px;
}

.register .wrapper .loginForm .reset-text {
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.register .wrapper .loginForm .reset-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
}

.register .wrapper .loginForm .register-text {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.register .wrapper .loginForm .register-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}

.register .wrapper .loginForm .login-btn {
  margin: @md1 0;
  width: 100%;
  height: 100px;
  border-radius: @br1*2;
  color: @black;
  background: linear-gradient(to right, #f4c57d, #f5a452);
  font-size: 30px;
  font-weight: bolder;
  border: none;
}

.register .wrapper .loginForm .agreement {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.register .wrapper .loginForm .agreement .agreement-text {
  // margin-left: 20px;
  padding-left: 1rem;
  font-size: 25px;
  color: #fff;
  font-weight: 500;
  line-height: 30px;
}

::v-deep .agreement .van-icon {
  font-size: 30px;
}

::v-deep .agreement .van-checkbox__icon {
  font-size: 38px;
}

::v-deep .agreement .van-checkbox__icon--checked .van-icon {
  color: #fff;
  border-color: rgb(126, 86, 120);
  background-color: rgb(126, 86, 120);
}

.bg-container.page {
  position: relative !important;
  min-height: 100vh;
  height: auto;
  overflow-x: hidden;
  overflow-y: auto;
  background: #000;
}
.bg-container.bc-img {
  background-image: url("/img/bg.e6263671.jpg");
  background-repeat: no-repeat;
  background-position: 0% center;
  background-size: auto 100%;
  filter: none;
  animation: authBgAutoScroll 18s ease-in-out infinite alternate;
}
.bg-wrapper.bc-img {
  position: relative;
  min-height: 100vh;
  height: 100%;
  background: rgba(0, 0, 0, 0.14);
  filter: none;
  animation: none;
}
.bc-box {
  background: transparent;
}
.bc-body {
  padding: 0 2.2rem;
}
@keyframes authBgAutoScroll {
  from {
    background-position: 0% center;
  }
  to {
    background-position: 100% center;
  }
}
.beauty-motion,
.icon-top {
  display: none;
}
.register .wrapper {
  min-height: calc(100vh - 100px);
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-sizing: border-box;
  padding-top: 17vh;
  padding-bottom: 2rem;
  overflow-y: auto;
}
.register .wrapper .loginForm {
  width: 100%;
  max-width: 26rem;
  margin: 0 auto;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
}
.register .wrapper .loginForm label {
  display: none;
}
.register .wrapper .loginForm .input1 {
  margin-bottom: 0.85rem;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
}
.register .wrapper .loginForm .input {
  height: 3.6rem;
  min-height: 3.6rem;
  padding: 0 1.35rem;
  margin-top: 0;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 0.55rem 1.4rem rgba(0, 0, 0, 0.16);
  line-height: normal;
  font-size: 1rem;
  display: flex;
  align-items: center;
}
::v-deep .loginForm .van-field__body {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
}
::v-deep .loginForm .van-field__control {
  color: #222 !important;
  font-size: 1rem;
  text-align: center;
  height: 1.4rem;
  line-height: 1.4rem;
  padding: 0;
}
::v-deep .loginForm .van-field__control::placeholder {
  color: #bdbdbd !important;
}
::v-deep .loginForm .van-field__right-icon {
  height: 100%;
  display: flex;
  align-items: center;
}
::v-deep .loginForm .van-field__right-icon .van-icon {
  color: #9a9a9a !important;
  font-size: 1.4rem;
}
.register .wrapper .loginForm .login-btn {
  width: 100%;
  height: 3.8rem;
  margin: 0.4rem 0 0;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #7c24e7 0%, #d8209d 100%);
  box-shadow: 0 0.7rem 1.5rem rgba(124, 36, 231, 0.26);
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
}
::v-deep .van-nav-bar__content {
  background: transparent !important;
}
::v-deep .van-nav-bar .van-icon {
  width: 2.7rem;
  height: 2.7rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.86);
  color: #222 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
}
.bg-wrapper.bc-img,
.bc-body,
.register .wrapper,
.register .wrapper .loginForm,
.register .wrapper .loginForm .input,
.register .wrapper .loginForm .login-btn {
  box-sizing: border-box;
}
.bg-wrapper.bc-img,
.register .wrapper {
  width: 100%;
}
.register .wrapper .loginForm {
  position: relative;
  top: auto;
  left: auto;
  right: auto;
  width: 84vw;
  max-width: 84vw;
  max-height: none;
  overflow-y: visible;
  margin: 0 auto;
}
.register .wrapper .loginForm .input {
  width: 100%;
  max-width: 100%;
  display: flex;
}
.register .wrapper .loginForm .login-btn {
  width: 100%;
  max-width: 100%;
  display: block;
}
</style>
